import { EmptyState } from 'ui/illustrations';
import { Link } from 'ui/links';

import { KNOWLEDGE_CENTER_ARTICLE_URL } from '../constants';
import {
  SettingsPlaceholderDescription,
  SettingsPlaceholderTitle,
  SettingsPlaceholderWrapper,
} from './styled';

const displayText = {
  noChannels: 'No channels yet',
  learnMore: 'Learn more by visiting our ',
  knowledgeCenter: 'Knowledge Center',
};

export const NoChannels = () => (
  <SettingsPlaceholderWrapper>
    <EmptyState width={128} height={128} data-test="no-channels-icon" />
    <SettingsPlaceholderTitle>{displayText.noChannels}</SettingsPlaceholderTitle>
    <SettingsPlaceholderDescription>
      {displayText.learnMore}{' '}
      <Link
        hasOpenNewTabIcon
        href={KNOWLEDGE_CENTER_ARTICLE_URL}
        rel="noopener noreferrer"
        target="_blank"
      >
        {displayText.knowledgeCenter}
      </Link>
      .
    </SettingsPlaceholderDescription>
  </SettingsPlaceholderWrapper>
);
